import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import iconSend from '../../../assets/images/icon-send.svg';
import { IsMobile } from '../../../helpers/IsMobile';
import ButtonWithIcon from '../ButtonWithIcon/ButtonWithIcon';
import ReferAccessButtonTooltip from '../ReferAccessButtonTooltip/ReferAccessButtonTooltip';

const SendReferralButton = ({ instantReferralLink, disabled = false, tooltipText }) => {
  const { t } = useTranslation('common');
  const mobile = IsMobile();
  const { pathname } = useLocation();

  const handleClick = () => {
    if (disabled) {
      return;
    }

    window.open(instantReferralLink, '_blank');
  };

  if (pathname.includes('/refer')) {
    return null;
  }

  return (
    <ReferAccessButtonTooltip blocked={disabled} tooltipText={tooltipText}>
      <ButtonWithIcon
        img={iconSend}
        imgClassName="btn-icon-36"
        text={mobile ? '' : t('buttons.sendReferral')}
        textClassName={mobile ? '' : 'btn-icon-text-primary-40'}
        variant="primary-36"
        onClick={handleClick}
        data-testid="send-referral-button"
        disabled={disabled}
      />
    </ReferAccessButtonTooltip>
  );
};

export default SendReferralButton;
